export const contentPagePath = '/page/:pageSlug';